<template>
  <v-card outlined>
    <v-card-text class="text-left" style="max-height: 430px; overflow-y: auto">
      <template v-if="!loading">
        <p v-html="consentdata.consent_details"></p>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import axios from "axios";
export default {
  props: {
    consentdata: null,
  },
  async mounted() {
    // await this.fetchData();
    this.loading = false;
  },
  data() {
    return {
      html: "",
      loading: true,
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>